import { useFormatNumber, useLocale } from '@dreamstack/i18n'
import { SimpleInput } from '@dreamstack/simple-components/src/lib/SimpleInput'
import { InputAdornment, Slider } from '@mui/material'
import type { FunctionComponent } from 'react'
import React, { useState } from 'react'
import { formatOptionsDecimal0, processUserInput } from './BTLCalcUtil'

export const BTLCalcFieldWithSlider: FunctionComponent<
  React.PropsWithChildren<{
    text: string
    value: number
    step: number
    maxValue: number
    maxText: string
    handler: Function
  }>
> = (props) => {
  const { text, value, maxValue, maxText, step, handler } = props
  const format = useFormatNumber(formatOptionsDecimal0)
  const locale = useLocale()

  const [textValue, setTextValue] = useState(format(value))
  const [errorText, setErrorText] = useState('')

  return (
    <div>
      <div className="flex flex-col md:flex-row mt-12">
        <div className="flex-1 flex flex-col justify-center text-left lg:text-right md:pr-px-24 pb-px-24 md:pb-0">
          <div className="font-semibold text-[16px]">{text}</div>
        </div>
        <div className="flex-1 flex flex-col justify-center md:pl-px-24">
          <SimpleInput
            className="w-full md:w-[368px] ml:w-[381px]"
            value={textValue}
            onBlur={() => {
              if (errorText) {
                setErrorText('')
              }
              setTextValue(format(value))
            }}
            onChange={(e) => {
              setTextValue(e.target.value)
              processUserInput(
                e.target.value,
                locale,
                maxValue,
                setErrorText,
                handler
              )
            }}
            inputProps={{
              style: {
                padding: 12,
                fontWeight: 600,
                fontSize: '20px',
              },
              inputMode: 'numeric',
            }}
            InputProps={{
              disableUnderline: true,
              endAdornment: (
                <InputAdornment position="end">
                  <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                    {'EUR'}
                  </span>
                </InputAdornment>
              ),
            }}
          />
          {errorText && (
            <div className="text-[13px] text-accentroRed-full">{errorText}</div>
          )}
        </div>
      </div>
      <div className="flex flex-col md:flex-row">
        <div className="flex-1 flex flex-col justify-center text-left md:text-right md:pr-px-24" />
        <div className="flex-1 flex flex-col justify-center md:pl-px-24">
          <div className="pt-px-12 w-full md:w-[368px] ml:w-[381px]">
            <Slider
              value={value}
              onChange={(e, v) => {
                setTextValue(format(v as number))
                handler(v)
              }}
              aria-labelledby="range-slider"
              min={0}
              max={maxValue}
              step={step}
            />
          </div>
        </div>
      </div>
      <div className="flex flex-col md:flex-row">
        <div className="flex-1 flex flex-col justify-center text-left md:text-right md:pr-px-24" />
        <div className="flex-1 flex flex-col justify-center md:pl-px-24">
          <div className="w-full md:w-[368px] ml:w-[381px] text-[14px]">
            <span>0 EUR</span>
            <span className="float-right">{maxText}</span>
          </div>
        </div>
      </div>
    </div>
  )
}
